import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDBetRecord implements ICommand
{

	public BetTime : number = 0;
	public BetID : number = 0;
	public GameID : number = 0;
	public BetType : number = 0;
	public BetAmount : number = 0;
	public RollingAmount : number = 0;
	public Remark : string = "";
	public Reason : string = "";
	public ResultAmount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.BetTime = ba.readInt53();
		this.BetID = ba.readInt53();
		this.GameID = ba.readInt53();
		this.BetType = ba.readUint8();
		this.BetAmount = ba.readInt53();
		this.RollingAmount = ba.readInt53();
		this.Remark = ba.readString();
		this.Reason = ba.readString();
		this.ResultAmount = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.BetTime);
		ba.writeUint53(this.BetID);
		ba.writeUint53(this.GameID);
		ba.writeUint8(this.BetType);
		ba.writeUint53(this.BetAmount);
		ba.writeUint53(this.RollingAmount);
		ba.writeString(this.Remark);
		ba.writeString(this.Reason);
		ba.writeUint53(this.ResultAmount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDBetRecord();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'BetTime(Q)='+this.BetTime+' ';
		str += 'BetID(Q)='+this.BetID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'BetType(B)='+this.BetType+' ';
		str += 'BetAmount(Q)='+this.BetAmount+' ';
		str += 'RollingAmount(Q)='+this.RollingAmount+' ';
		str += 'Remark(S)='+this.Remark+' ';
		str += 'Reason(S)='+this.Reason+' ';
		str += 'ResultAmount(Q)='+this.ResultAmount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'BetRecord';
	}

}
